function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgTornado = function SvgTornado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M432,183.229H48c-4.416,0-8-3.576-8-8s3.584-8,8-8h384c4.424,0,8,3.576,8,8 S436.424,183.229,432,183.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M176,135.229H8c-4.416,0-8-3.576-8-8c0-4.424,3.584-8,8-8h168c4.416,0,8,3.576,8,8 C184,131.653,180.416,135.229,176,135.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M176,39.229H40c-4.416,0-8-3.576-8-8s3.584-8,8-8h136c4.416,0,8,3.576,8,8 S180.416,39.229,176,39.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M432,39.229h-88c-4.424,0-8-3.576-8-8s3.576-8,8-8h88c4.424,0,8,3.576,8,8 S436.424,39.229,432,39.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M136,87.229H8c-4.416,0-8-3.576-8-8s3.584-8,8-8h128c4.416,0,8,3.576,8,8S140.416,87.229,136,87.229 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M472,135.229H304c-4.424,0-8-3.576-8-8c0-4.424,3.576-8,8-8h168c4.424,0,8,3.576,8,8 C480,131.653,476.424,135.229,472,135.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M472,87.229h-96c-4.424,0-8-3.576-8-8s3.576-8,8-8h96c4.424,0,8,3.576,8,8 S476.424,87.229,472,87.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M400,231.229H216c-4.416,0-8-3.576-8-8s3.584-8,8-8h184c4.424,0,8,3.576,8,8 S404.424,231.229,400,231.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M384,279.229H248c-4.416,0-8-3.576-8-8s3.584-8,8-8h136c4.424,0,8,3.576,8,8 S388.424,279.229,384,279.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M336,327.229H144c-4.416,0-8-3.576-8-8s3.584-8,8-8h192c4.424,0,8,3.576,8,8 S340.424,327.229,336,327.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M296,375.229H176c-4.416,0-8-3.576-8-8s3.584-8,8-8h120c4.424,0,8,3.576,8,8 S300.424,375.229,296,375.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M272,423.229h-64c-4.416,0-8-3.576-8-8s3.584-8,8-8h64c4.424,0,8,3.576,8,8 S276.424,423.229,272,423.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M256,471.229h-32c-4.416,0-8-3.576-8-8s3.584-8,8-8h32c4.424,0,8,3.576,8,8 S260.424,471.229,256,471.229z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M112.888,440.557c12.68-21.96,10.224-48.496-4.104-67.552c-23.672-2.88-47.88,8.264-60.56,30.224 s-10.232,48.496,4.104,67.552C76.008,473.661,100.208,462.517,112.888,440.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M117.728,372.173l10.424-18.056c2.208-3.832,0.896-8.72-2.928-10.928 c-3.84-2.208-8.72-0.888-10.928,2.928l-10.76,18.64c-25.44-0.856-49.36,12.16-62.232,34.472 c-13.928,24.12-12.112,54.096,4.632,76.36c1.312,1.744,3.264,2.872,5.424,3.136c2.832,0.352,5.648,0.512,8.448,0.512 c24.568,0,47.504-13.024,60.008-34.68l0,0C132.952,421.821,131.904,393.957,117.728,372.173z M105.96,436.557L105.96,436.557 c-10.136,17.56-29.144,27.632-49.224,26.592c-11.016-16.784-11.72-38.368-1.576-55.92c8.368-14.496,22.816-23.808,38.888-26.04 l-28.336,49.072c-2.208,3.832-0.896,8.72,2.928,10.928c1.264,0.728,2.64,1.072,3.992,1.072c2.768,0,5.456-1.44,6.936-4l28.88-50.016 C115.296,403.621,114.624,421.549,105.96,436.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M98.416,289.301c24.488-6.56,41.52-27.056,44.864-50.672c-14.704-18.776-39.704-28.016-64.192-21.448 s-41.52,27.056-44.864,50.672C48.928,286.629,73.92,295.861,98.416,289.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M175.984,229.173c-1.144-4.272-5.544-6.816-9.8-5.656l-20.792,5.568 c-17.384-18.536-43.48-26.312-68.376-19.64c-26.904,7.208-46.816,29.688-50.72,57.272c-0.304,2.16,0.28,4.344,1.624,6.056 c13.368,17.08,33.576,26.624,54.568,26.624c5.984,0,12.024-0.776,18-2.376c25.368-6.8,44.336-27.232,49.712-52.664l20.128-5.392 C174.592,237.829,177.128,233.437,175.984,229.173z M96.344,281.573c-19.568,5.224-40.248-1.024-53.608-16.008 c4.08-19.656,18.84-35.416,38.424-40.664c16.168-4.312,33.008-0.704,45.936,9.088l-54.76,14.672c-4.272,1.144-6.8,5.528-5.656,9.8 c0.96,3.576,4.184,5.928,7.72,5.928c0.68,0,1.384-0.088,2.072-0.272l55.792-14.944C126.24,264.885,113.08,277.085,96.344,281.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M400.064,433.301c-24.488-6.56-41.52-27.056-44.864-50.672 c14.704-18.776,39.704-28.016,64.192-21.448c24.488,6.56,41.52,27.056,44.864,50.672 C449.552,430.629,424.56,439.861,400.064,433.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M421.464,353.445c-24.864-6.672-50.976,1.112-68.368,19.64l-20.808-5.576 c-4.264-1.128-8.656,1.392-9.8,5.656s1.392,8.656,5.656,9.8l20.136,5.392c5.384,25.424,24.344,45.864,49.712,52.664 c5.968,1.6,12.008,2.376,17.992,2.376c20.984,0,41.192-9.544,54.56-26.624c1.344-1.712,1.928-3.896,1.624-6.056 C468.272,383.133,448.368,360.661,421.464,353.445z M402.144,425.573c-16.736-4.488-29.896-16.688-35.928-32.408L422,408.109 c0.696,0.184,1.392,0.272,2.08,0.272c3.528,0,6.768-2.36,7.72-5.928c1.144-4.264-1.392-8.656-5.656-9.8l-54.752-14.664 c12.928-9.792,29.792-13.408,45.936-9.088c19.576,5.248,34.344,21.008,38.424,40.664 C442.384,424.549,421.728,430.805,402.144,425.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M240.448,39.461c-12.68,21.96-10.224,48.496,4.104,67.552c23.672,2.88,47.88-8.264,60.56-30.224 s10.232-48.496-4.104-67.552C277.328,6.357,253.128,17.501,240.448,39.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M307.408,4.429c-1.312-1.744-3.272-2.872-5.432-3.136c-27.68-3.432-54.536,10.04-68.464,34.168 c-13.128,22.736-12.088,50.6,2.088,72.384l-10.424,18.056c-2.208,3.832-0.896,8.72,2.928,10.928c1.264,0.728,2.64,1.072,3.992,1.072 c2.768,0,5.456-1.44,6.936-4l10.72-18.568c0.752,0.024,1.52,0.136,2.272,0.136c24.56,0,47.504-13.024,60.008-34.68 C325.96,56.685,324.152,26.709,307.408,4.429z M298.176,72.789c-8.36,14.496-22.864,23.792-38.888,26.032l28.328-49.064 c2.208-3.832,0.896-8.72-2.928-10.928s-8.72-0.896-10.928,2.928l-28.872,50.016c-6.848-15.384-6.176-33.304,2.496-48.312 c10.136-17.56,29.128-27.672,49.224-26.592C307.608,33.661,308.32,55.245,298.176,72.789z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTornado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tornado.f511bc84.svg";
export { ForwardRef as ReactComponent };